import { render, staticRenderFns } from "./video.vue?vue&type=template&id=68721325&scoped=true&"
import script from "./video.vue?vue&type=script&lang=js&"
export * from "./video.vue?vue&type=script&lang=js&"
import style0 from "./video.vue?vue&type=style&index=0&lang=css&"
import style1 from "./video.vue?vue&type=style&index=1&id=68721325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68721325",
  null
  
)

export default component.exports